<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModalPrincipal" :title="prefix + title"
        @hidden="cancelar">

        <b-card no-body>
            <b-card-body>

                <b-card bg-variant="light">

                    <div style="
                                    width: 100%;
                                    display: flex;
                                    align-items: center;
                                    padding-left: 16px;
                                    justify-content: space-between;
                                     padding-bottom: 16px;
                                     padding-right: 16px;
                                     padding-top: 16px;
                                     margin-bottom: 16;
                                    " class="subrow">
                        <div style="width: 56%; display: flex; gap: 8px;">
                            {{ produto.descricaoProduto }}
                        </div>
                        <div style="display: flex; gap: 8px; width: 44%;">
                            <div style="width: 32%">{{ produto.numeroProduto }}</div>

                            <div style="width: 15%;margin-left: 15%;">{{ produto.tipoMedida }}</div>

                            <div style="width: calc(38% - 37px)">
                            </div>
                            <div
                                style="width: 27px; text-align: right; display: flex; justify-content: flex-end; gap: 6px;">


                                <b-button v-if="temPrivilegioEdicao() && anoAtual == ano"
                                    v-b-tooltip.hover.top="records && records.length > 0 ? 'Adicionar contagem...' : 'Adicionar nova contagem...'"
                                    @click="clickAdicionarNovoItem(produto)" variant="primary" size="sm"
                                    class="align-items-center justify-content-center">
                                    <b-icon icon="plus" />

                                </b-button>
                            </div>
                        </div>
                    </div>


                    <b-table :items="records" :fields="tableFields" :busy="busy" small hover show-empty>

                        <template v-slot:cell(diferenca)="{ item }">

                            {{ item.saldoFisico - item.saldoSpalm }}
                        </template>
                        <template v-slot:cell(lote)="{ item }">
                            {{ item.lote ? item.lote : "Sem Lote" }}
                        </template>

                        <template v-slot:cell(dataContagem)="{ item }">
                            {{ formatDate(item.dataContagem) }}
                        </template>
                        <template v-slot:cell(editar)="{ item }">

                            <b-button v-b-tooltip.hover.top="'Editar contagem...'"
                                v-if="(anoAtual == ano && produto.estaNoMesmoDia && item.isUltimo) || isAdmin()"
                                @click="clickEditarNovoItem(item)" variant="primary" size="sm"
                                class="align-items-center justify-content-center">
                                <b-icon icon="pencil-square" />
                            </b-button>
                        </template>
                        <template v-slot:cell(editarJustificativa)="{ item }">

                            <b-button v-b-tooltip.hover.top="'Adicionar observação'"
                                v-if="(anoAtual == ano && produto.estaNoMesmoDia && item.isUltimo) || isAdmin()"
                                @click="clickAdicionarJustificativa(item)" variant="primary" size="sm"
                                class="align-items-center justify-content-center">
                                <b-icon icon="file-earmark-text" />
                            </b-button>
                        </template>
                        <template v-slot:cell(trash)="{ item }">


                            <b-button v-b-tooltip.hover.top="'Excluir contagem'"
                                v-if="(anoAtual == ano && produto.estaNoMesmoDia && item.isUltimo) || isAdmin()"
                                @click="removerItem(item)" variant="primary" size="sm"
                                class="align-items-center justify-content-center">
                                <b-icon icon="trash" />
                            </b-button>


                        </template>

                        <template #empty>
                            <p class="text-center">Nenhum registro encontrado</p>
                        </template>

                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle" />
                            </div>
                        </template>



                    </b-table>

                    <b-row style="margin-top: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page
                            }} de
                                {{
                                    totalPage }} -
                                {{ total }} registros</b-col>
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                    :options="perPageOptions">
                                </b-form-select>
                            </b-col>
                        </b-col>
                        <b-col cols="6">
                            <div class="d-flex justify-content-end align-items-end">
                                <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                    :per-page="perPage" :total-rows="total"></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>

            </b-card-body>

            <b-modal size="sm" button-size="sm" hide-footer v-if="adicionarJustificativa"
                v-model="adicionarJustificativa" @hidden="closeAdicionarJustificativa"
                :title="prefix + title + ' > Observação para ajuste de Estoque'">

                <lg-form-input invalidFeedback=" " description="" v-model="justificativa" label="Observação:*" lg="12"
                    sm="12" md="12" />

                <b-form-row>

                    <b-col cols="2"></b-col>
                    <b-col cols="8" class="text-center">
                        <b-button id="salvar-justificativa" class=" my-2" size="sm" pill variant="success"
                            @click="saveAdicionarJustificativa">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="salvar-justificativa" title="Salvar"></b-tooltip>

                        </b-button>

                        <b-button id="cancelar-modal" class=" my-2 ml-2" size="sm" pill variant="danger"
                            @click="closeAdicionarJustificativa">
                            <b-icon icon="x-circle" />
                            <b-tooltip target="cancelar-modal" title="Cancelar"></b-tooltip>

                        </b-button>

                        <b-button id="remover-justificativa" class=" my-2 ml-2" size="sm" pill variant="danger"
                            @click="removerJustificativa">
                            <b-icon icon="trash" />
                            <b-tooltip target="remover-justificativa" title="Remover justificativa"></b-tooltip>

                        </b-button>
                    </b-col>
                    <b-col cols="2"></b-col>

                </b-form-row>

            </b-modal>


            <b-modal size="sm" button-size="sm" hide-footer v-if="adicionarNovoItem" v-model="adicionarNovoItem"
                :title="prefix + title + ' > Contagem > Cadastro'" @hidden="closeAdicionarNovoItem">

                <b-col v-if="!editarItem">
                    <b-form-group label="Lotes:*">
                        <b-form-select v-model="lote" @change="mudarLote" :options="saldos" size="sm" />
                    </b-form-group>
                </b-col>
                <lg-form-input v-if="atualizarSaldoFlag" invalidFeedback=" " disabled description=""
                    v-model="itemInventarioModelo.saldoSpalm" label="Saldo:*" lg="12" sm="12" md="12" />

                <lg-form-input invalidFeedback=" " description="" v-model="itemInventarioModelo.saldoFisico"
                    label="Quant. Inventário:*" lg="12" sm="12" md="12" />

                <lg-form-input invalidFeedback=" " description="" v-model="justificativa" label="Observação:" lg="12"
                    sm="12" md="12" />



                <b-form-row>

                    <b-col cols="2"></b-col>
                    <b-col cols="8" class="text-center">
                        <b-button id="salvar-item" class=" my-2" size="sm" pill variant="success" @click="salvarItem">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="salvar-item" title="Salvar"></b-tooltip>

                        </b-button>

                        <b-button id="cancelar-item" class=" my-2 ml-2" size="sm" pill variant="danger"
                            @click="closeAdicionarNovoItem">
                            <b-icon icon="x-circle" />
                            <b-tooltip target="cancelar-item" title="Cancelar"></b-tooltip>

                        </b-button>

                    </b-col>
                    <b-col cols="2"></b-col>

                </b-form-row>

            </b-modal>
        </b-card>
    </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ResourceService from "@/core/api/ResourceService"
import moment from "moment";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import { ListResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import StatusEnum from "@/core/utils/StatusEnum";
import { isUserAdmin } from '@/core/auth';
import Swal from "sweetalert2"
export default {
    components: {
        LgFormInput,
    },
    mixins: [ConfirmMixin, ListResourceMixin],

    props: {
        id: Number,
        produto: Object,
        almoxarifado: Object,
        apenasSaldoPositivo: {
            type: Boolean,
            default: false,
        },

        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Cadastro"
        }
    },
    data() {

        return {
            atualizarSaldoFlag: false,
            saldos: [],
            lote: 0,
            anoAtual: 0,
            editarItem: false,
            idInventarioItemBemConsumo: null,
            showConsulta: false,

            itemInventarioModelo: null,
            justificativa: "",
            adicionarJustificativa: false,
            adicionarNovoItem: false,
            itemInventario: null,
            item: null,
            statusEmDigitacao: StatusEnum.INVENTARIO_EM_DIGITACAO.value,
            statusEmAndamento: StatusEnum.INVENTARIO_EM_ANDAMENTO.value,

            anos: [],
            ano: null,
            perpage: 10,
            perPageOptions: [10, 25, 50, 100, 1000, 2000],

            showModalPrincipal: true,
            busy: false,
            form: {
                almoxarifado: {},
                produto: {},
                subgrupo: {},
                classe: {},
                localArmazenamento1: {},
                tipoMedida: {},
                localArmazenamento2: {},
                lotePositivo: false,
                saldoPositivo: this.apenasSaldoPositivo,
                natureza: {},
                ordenarRelatorio: false,
                disponibilidade: null,
                visibilidade: null,
                departamento: {},
                pessoaComissao: null,
                comissao: null,
                responsavel: null,
            },
            expandSubrow: {},

            tableFields: [


                { key: "lote", label: "Lote" },
                { key: "saldoSpalm", label: "Saldo SPALM" },
                { key: "saldoFisico", label: "Saldo Físico" },
                { key: "diferenca", label: "Diferença", },
                { key: "dataContagem", label: "Data Contagem" },
                { key: "local1", label: "Local Armazenamento 1" },
                { key: "local2", label: "Local Armazenamento 2" },

                { key: "responsavelProduto", label: "Responsável", tdClass: "text-center", thClass: "text-center" },
                { key: "justificativa", label: "Observação", tdClass: "text-center", thClass: "text-center" },
                { key: "editar", label: " ", tdClass: "text-center", thClass: "text-center" },
                { key: "editarJustificativa", label: " ", tdClass: "text-center", thClass: "text-center" },
                { key: "trash", label: " ", tdClass: "text-center", thClass: "text-center" },

            ],

        };
    },
    watch: {
        page() {
            this.load();
        },
    },

    methods: {
        formatDate(date) {

            if (!date || date == "")
                return "";

            return moment(date).format("DD/MM/YYYY");
        },

        cancelar() {
            this.$emit("close");
        },
        async removerItem(item) {
            const value = await Swal.fire({
                title: "Tem certeza que deseja excluir a contagem?",
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value;
            });

            if (!value) {
                return;
            }

            this.busy = true;
            await this.$serviceInventario.delete(`remover-contagem/${item.idItemInventario}`);
            this.$notify({
                type: "success",
                message: `Contagem removida com sucesso!`,
            });
            this.load();

        },
        isAdmin() {
            return isUserAdmin();
        },
        async removerJustificativa() {
            await this.$serviceInventario.delete(`remover-justificativa/${this.itemInventario}`);
            this.$notify({
                type: "success",
                message: `Observação removida com sucesso!`,
            });


            this.closeAdicionarJustificativa();
        },
        async saveAdicionarJustificativa() {

            if (!this.justificativa || this.justificativa === "") {
                this.$notify({
                    type: "danger",
                    message: `Digite a observação!`,
                });

                return;
            }

            await this.$serviceInventario.put(`adicionar-justificativa/${this.itemInventario}`, { justificativa: this.justificativa });
            this.$notify({
                type: "success",
                message: `Observação adicionada com sucesso!`,
            });

            this.closeAdicionarJustificativa();

        },
        closeAdicionarJustificativa() {
            this.itemInventario = null;
            this.adicionarJustificativa = false;
            this.justificativa = "";
            this.load();
        },
        clickAdicionarJustificativa(item) {
            this.justificativa = item.justificativa;
            this.itemInventario = item.idItemInventario;
            this.adicionarJustificativa = true;
        },
        salvarItem() {
            if (this.editarItem) {
                this.editAdicionarNovoItem();
            } else {
                this.saveAdicionarNovoItem();
            }
        },
        async saveAdicionarNovoItem() {

            if (this.lote == 0) {
                this.$notify({
                    type: "danger",
                    message: `Escolha um Lote para a contagem`,
                });
                return;
            }

            if (!this.itemInventarioModelo.saldoFisico || this.itemInventarioModelo.saldoFisico <= 0) {
                this.$notify({
                    type: "danger",
                    message: `Digite a quantidade no inventário!`,
                });

                return;

            }

            const item = {

                idInventarioItemBemConsumo: this.itemInventarioModelo.idInventarioItemBemConsumo,
                saldoAlmoxarifadoProduto: this.itemInventarioModelo.saldoAlmoxarifadoProduto,
                justificativa: this.justificativa,
                saldoSpalm: this.itemInventarioModelo.saldoSpalm,
                saldoFisico: this.itemInventarioModelo.saldoFisico
            }
            await this.$serviceInventario.post(`adicionar-item-inventario-item-bem-consumo`, item);
            this.$notify({
                type: "success",
                message: `Contagem adicionada com sucesso!`,
            });

            this.closeAdicionarNovoItem();

        },

        async editAdicionarNovoItem() {


            if (!this.itemInventarioModelo.saldoFisico || this.itemInventarioModelo.saldoFisico <= 0) {
                this.$notify({
                    type: "danger",
                    message: `Digite a quantidade no inventário!`,
                });

                return;

            }

            const item = {

                id: this.itemInventarioModelo.idItemInventario,
                idInventarioItemBemConsumo: this.itemInventarioModelo.idInventarioItemBemConsumo,
                saldoAlmoxarifadoProduto: this.itemInventarioModelo.saldoAlmoxarifadoProduto,
                justificativa: this.justificativa,
                saldoSpalm: this.itemInventarioModelo.saldoSpalm,
                saldoFisico: this.itemInventarioModelo.saldoFisico
            }
            await this.$serviceInventario.put(`editar-item-inventario-item-bem-consumo`, item);
            this.$notify({
                type: "success",
                message: `Contagem editada com sucesso!`,
            });

            this.closeAdicionarNovoItem();

        },
        closeAdicionarNovoItem() {
            this.itemInventarioModelo = null;
            this.justificativa = "";
            this.editarItem = false;
            this.lote = 0;
            this.saldos = [];
            this.adicionarNovoItem = false;
            this.load();
        },
        mudarLote(lote) {

            this.lote = lote;
            this.atualizarSaldoFlag = false;
            var saldo = this.saldos.find(item => item.value == lote);

            this.itemInventarioModelo.saldoAlmoxarifadoProduto = saldo.value;
            this.itemInventarioModelo.saldoSpalm = saldo.saldoAlmoxarifadoProduto;

            this.atualizarSaldoFlag = true;
        },

        async clickAdicionarNovoItem() {
            this.lote = 0;
            this.saldos = [];
            this.atualizarSaldoFlag = true;
            this.itemInventarioModelo = {};
            this.itemInventarioModelo.idInventarioItemBemConsumo = this.produto.idInventarioItemBemConsumo;
            this.itemInventarioModelo.saldoSpalm = "";
            this.itemInventarioModelo.saldoFisico = "";
            this.justificativa = "";
            this.editarItem = false;

            var { data } = await this.$serviceInventario.getWithParams("item-inventario-saldos",
                { almoxarifado: this.produto.idAlmoxarifado, produto: this.produto.idProduto });

            if (data && data.length > 0) {
                this.saldos = data.map(x => ({
                    value: x.saldoAlmoxarifadoProduto,
                    text: x.lote,
                    saldoAlmoxarifadoProduto: x.saldo
                }));
                this.adicionarNovoItem = true;
                if (this.saldos.length == 1) {
                    this.mudarLote(this.saldos[0].value);
                }
            }
            else {

                this.$notify({
                    type: "danger",
                    message: `Não é possível realizar a contagem de um item que não tem saldo no almoxarifado`,
                });
                this.closeAdicionarNovoItem();
            }
        },

        clickEditarNovoItem(item) {

            this.itemInventarioModelo = item;
            this.editarItem = true;
            this.justificativa = item.justificativa;
            this.adicionarNovoItem = true;
        },
        handleToggleExpandSubrow(produto) {
            this.expandSubrow = {
                ...this.expandSubrow,
                [produto.idProduto]: !this.expandSubrow[produto.idProduto],
            }
        },

        async inventariar(inventario) {
            this.busy = true;
            await this.$serviceInventario.put(`inventariar/${inventario.id}`);
            this.$notify({
                type: "success",
                message: `Inventário iniciado com sucesso!`,
            });

            this.busy = false;
            this.load();

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.INVENTARIOS_CONTINUAR);

        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.INVENTARIOS_INCLUIR);

        },

        async load() {


            var filtro = {};
            filtro.id = this.id;
            filtro.produto = this.produto.idProduto;
            filtro.almoxarifado = this.almoxarifado.id;

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });

        },


    },
    async beforeMount() {

        this.$serviceInventario = new ResourceService("/api/inventario-ibc");
        this.$service = new ResourceService("/api/inventario-ibc/item-inventario");
        this.$serviceExercicio = new ResourceService("/api/exercicio-fiscal");

        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento

        this.busy = true;
        var ano = (await new ResourceService("/api/util").get("buscar-ano-atual")).data;
        this.ano = ano;
        this.anoAtual = ano;
        this.anos = (await this.$serviceExercicio.get("todos-anos")).data;

        this.load();
    },
};
</script>
